export const pagesCustomersEn = {
  add: {
    fields: {
      businessPartner: 'Business Partner',
      endDate: 'End Date',
      note: 'Note',
      owner: 'Owner',
      phase: 'Phase',
      startDate: 'Start Date',
      status: 'Status',
      tier: 'Scale'
    },
    nextButton: 'Next',
    pageTitle: 'Add Customer',
    placeholders: {
      businessPartner: 'Select a business partner',
      endDate: 'Select end date',
      note: 'Enter a note',
      owner: 'Select an owner',
      startDate: 'Select start date'
    },
    previousButton: 'Back',
    progressbar: {
      filled: 'Filled',
      modeSetting: 'Input Mode',
      mustItem: 'Required Items',
      mustItemOnly: 'Required fields only',
      progressCircle: 'Progress Circle',
      title: 'Progress',
      total: 'All Items'
    },
    sections: {
      basicInfo: 'Basic Information',
      contract: 'Contract & Notes'
    },
    stepper: {
      basic: 'Basic Information',
      contract: 'Contract & Notes',
      title: 'Sections'
    },
    submit: 'Create',
    toast: {
      error: 'Failed to create the customer',
      success: 'Created the customer'
    },
    validation: {
      required: 'Required'
    }
  },
  addSelect: {
    fillOutDetails: 'Fill out details',
    formCardTitle: 'Enter details (form)',
    pageTitle: 'Add Customer',
    requiredFields: {
      businessPartner: 'Business Partner',
      phase: 'Phase',
      status: 'Status'
    },
    requiredItems: 'Required items',
    selectionTitle: 'Choose how to add'
  },
  detail: {
    breadcrumb: {
      customers: 'Customers',
      home: 'Home'
    },
    header: {
      meta: {
        endDate: 'End Date',
        owner: 'Owner',
        startDate: 'Start Date',
        unset: 'Not set'
      }
    },
    profile: {
      fields: {
        businessPartner: 'Business Partner',
        code: 'Code',
        endDate: 'End Date',
        owner: 'Owner',
        phase: 'Phase',
        startDate: 'Start Date',
        status: 'Status',
        tier: 'Scale'
      },
      sections: {
        basic: 'Basic Information',
        contract: 'Usage Status & Owner'
      },
      toast: {
        updateError: 'Failed to update the customer',
        updateSuccess: 'Updated the customer'
      }
    },
    relatedIncidents: {
      columns: {
        code: 'Incident ID',
        detectedAt: 'Detected At',
        internalStatus: 'Status',
        severity: 'Severity',
        title: 'Title'
      },
      noResults: 'No related incidents.'
    },
    relatedIncidentsEdit: {
      addDialog: {
        addButton: 'Add',
        empty: 'No incidents available to add',
        searchPlaceholder: 'Search by ID or title',
        title: 'Add incidents'
      },
      addIncidents: '+ Add incidents',
      changeButton: 'Change Incidents',
      currentIncidents: {
        columns: {
          code: 'Incident ID',
          severity: 'Severity',
          title: 'Title'
        },
        empty: 'No incidents are linked',
        remove: 'Remove'
      },
      done: 'Done',
      pageTitle: 'Edit Related Incidents',
      stepSelectIncidents: 'Select incidents',
      toast: {
        addError: 'Failed to add incidents',
        addSuccess: 'Linked {{count}} incident(s) to the customer',
        removeError: 'Failed to remove the incident',
        removeSuccess: 'Removed the incident from the customer'
      }
    },
    relatedIssues: {
      columns: {
        name: 'Issue Name',
        note: 'Reported Notes',
        reportedAt: 'Reported Date',
        severity: 'Severity',
        status: 'Status'
      },
      noResults: 'No related issues.'
    },
    relatedIssuesEdit: {
      addDialog: {
        addButton: 'Add',
        empty: 'No issues available to add',
        searchPlaceholder: 'Search by name',
        title: 'Add issues'
      },
      addIssues: '+ Add issues',
      changeButton: 'Change Issues',
      currentIssues: {
        columns: {
          name: 'Issue Name',
          severity: 'Severity',
          status: 'Status'
        },
        empty: 'No issues are linked',
        remove: 'Remove'
      },
      done: 'Done',
      pageTitle: 'Edit Related Issues',
      stepSelectIssues: 'Select issues',
      toast: {
        addError: 'Failed to add issues',
        addSuccess: 'Linked {{count}} issue(s) to the customer',
        removeError: 'Failed to remove the issue',
        removeSuccess: 'Removed the issue from the customer'
      }
    },
    tabs: {
      profile: 'Profile',
      relatedIncidents: 'Incidents',
      relatedIssues: 'Issues',
      targetNodes: 'Used Functions',
      values: 'Values'
    },
    targetNodes: {
      empty: 'No functions in use are registered.',
      table: {
        headers: {
          kind: 'Type',
          name: 'Name',
          publishStatus: 'Publish Status'
        }
      }
    },
    targetNodesEdit: {
      changeButton: 'Change Used Functions',
      done: 'Done',
      empty: 'No functions found',
      toast: {
        addError: 'Failed to link used functions',
        addSuccess: 'Linked {{count}} function(s) to the customer',
        removeError: 'Failed to unlink the used function',
        removeSuccess: 'Unlinked the used function from the customer'
      }
    },
    values: {
      columns: {
        code: 'Code',
        layer: 'Layer',
        linkedAt: 'Linked Date',
        status: 'Status',
        title: 'Title',
        valueProposition: 'Value Proposition'
      },
      noResults: 'No values are linked.'
    },
    valuesEdit: {
      addDialog: {
        addButton: 'Add',
        empty: 'No values available to add',
        searchPlaceholder: 'Search by title',
        title: 'Add values'
      },
      addValues: '+ Add values',
      changeButton: 'Change Values',
      currentValues: {
        columns: {
          code: 'Code',
          layer: 'Layer',
          status: 'Status',
          title: 'Title',
          valueProposition: 'Value Proposition'
        },
        empty: 'No values are linked',
        remove: 'Remove'
      },
      done: 'Done',
      pageTitle: 'Edit Linked Values',
      stepSelectValues: 'Select values',
      toast: {
        addError: 'Failed to add values',
        addSuccess: 'Linked {{count}} value(s) to the customer',
        removeError: 'Failed to remove the value',
        removeSuccess: 'Removed the value from the customer'
      }
    }
  },
  list: {
    addCustomer: 'Add',
    columns: {
      businessPartner: 'Business Partner',
      code: 'Code',
      owner: 'Owner',
      phase: 'Phase',
      startDate: 'Start Date',
      status: 'Status',
      tier: 'Scale',
      usedProducts: 'Products in Use'
    },
    filters: {
      phase: 'Phase',
      tier: 'Scale'
    },
    noResults: 'No customers found.',
    pageTitle: 'Customers',
    searchPlaceholder: 'Search by partner name or code...',
    statusTabs: {
      ACTIVE: 'Active',
      ALL: 'All',
      SUSPENDED: 'Suspended',
      TERMINATED: 'Terminated'
    },
    tabLabel: 'Customer List'
  },
  options: {
    phase: {
      IN_PRODUCTION: 'In Production',
      ONBOARDING: 'Onboarding',
      PRE_ONBOARDING: 'Pre-onboarding'
    },
    status: {
      ACTIVE: 'Active',
      SUSPENDED: 'Suspended',
      TERMINATED: 'Terminated'
    },
    tier: {
      ENTERPRISE: 'Enterprise',
      MID: 'Mid-market',
      SMB: 'SMB'
    }
  },
  title: 'Customers'
};